import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";

const VehicleStatus = () => {
  const { data, loading } = UseGetDashBoardData(`/new-dashboard/vehicle-details`);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 17a2 2 0 100 4 2 2 0 000-4zm10 0a2 2 0 100 4 2 2 0 000-4zM4 9h11l3 4v4H4V9z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Vehicle Fleet Operational Status</h3>
        </div>

        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200/50">
          Fleet Logs
        </span>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Vehicle Name</th>
                <th className="py-2 px-2 text-left">Plate No.</th>
                <th className="py-2 px-1 text-center">Condition</th>
                <th className="py-2 px-2 text-right">Assignee</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => {
                  const cond = (item?.condition || "Good").toLowerCase();
                  const isGood = cond.includes("good") || cond.includes("working") || cond.includes("active");
                  const isBad = cond.includes("repair") || cond.includes("damaged") || cond.includes("breakdown");

                  return (
                    <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                      <td className="py-2.5 px-2 font-semibold text-gray-900 truncate max-w-[120px]">
                        {item?.name || "N/A"}
                      </td>
                      <td className="py-2.5 px-2 font-mono text-gray-700 font-medium">{item?.plateNo || "N/A"}</td>
                      <td className="py-2.5 px-1 text-center">
                        <span
                          className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${
                            isGood
                              ? "bg-emerald-50 text-emerald-700 border-emerald-200/50"
                              : isBad
                              ? "bg-rose-50 text-rose-700 border-rose-200/50"
                              : "bg-amber-50 text-amber-700 border-amber-200/50"
                          }`}
                        >
                          {item?.condition || "Active"}
                        </span>
                      </td>
                      <td className="py-2.5 px-2 text-right text-gray-600 truncate max-w-[110px]">
                        {item?.assignedTo || "Unassigned"}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="py-6 text-center text-gray-400">
                    No vehicle details available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VehicleStatus;